import { Component, OnInit } from '@angular/core'
import { ModalService } from '../../../../services/modal.service'
import { SharedServices } from '../../../../services/shared.services'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'

declare var jQuery: any

@Component({
    selector: 'app-theme',
    templateUrl: './theme.component.html',
    styleUrls: ['../../../../stagingcss/root-ui-view.component.css', '../../../../stagingcss/main-body.component.css', '../../../../stagingcss/main-view.component.css', '../../../../stagingcss/lui-select.component.css'],
})
export class ThemeComponent implements OnInit {
    hiddenModalTheme = 'hidden'
    activeTheme = 'blue'

    constructor(private modalService: ModalService, private _sharedService: SharedServices, private authData: AuthService, private restApi: RestServices) {
        modalService.changeEmitted$.subscribe(success => {
            // task common
            if (success === 'activeChooseTheme') {
                this.hiddenModalTheme = 'active'
            }
        })
        this.activeTheme = localStorage.getItem('classThemeBody')
    }

    ngOnInit() {
    }

    chooseTheme(action) {
        jQuery('body').attr('class', action)
        localStorage.setItem('classThemeBody', action)
        this.activeTheme = action
        this.hiddenModalTheme = 'hidden'
        if (action === 'blue') {
            const urlLogo = 'assets/img/logo.png'
            localStorage.setItem('urlLogo', urlLogo)
        } else if (action === 'green') {
            const urlLogo = 'assets/img/logo1.png'
            localStorage.setItem('urlLogo', urlLogo)
        } else if (action === 'red') {
            const urlLogo = 'assets/img/logo2.png'
            localStorage.setItem('urlLogo', urlLogo)
        } else if (action === 'lemon') {
            const urlLogo = 'assets/img/logo3.png'
            localStorage.setItem('urlLogo', urlLogo)
        } else if (action === 'origin') {
            const urlLogo = 'assets/img/logo4.png'
            localStorage.setItem('urlLogo', urlLogo)
        } else if (action === 'violet') {
            const urlLogo = 'assets/img/logo5.png'
            localStorage.setItem('urlLogo', urlLogo)
        } else if (action === 'black') {
            const urlLogo = 'assets/img/logo6.png'
            localStorage.setItem('urlLogo', urlLogo)
        }
        const resourceData = {
            actions: [{
                type: 'update', collection: 'setting', id: 'common', value: {
                    chooseTheme: action,
                },
            }], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe()
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/theme/theme.component.ts